import { proxy, subscribe as sub } from 'valtio/vanilla';
import { subscribeKey as subKey } from 'valtio/vanilla/utils';
import { CoreHelperUtil } from '../utils/CoreHelperUtil.js';
import { ApiController } from './ApiController.js';
import { ChainController } from './ChainController.js';
import { ConnectorController } from './ConnectorController.js';
import { EventsController } from './EventsController.js';
import { OptionsController } from './OptionsController.js';
import { PublicStateController } from './PublicStateController.js';
import { RouterController } from './RouterController.js';
// -- State --------------------------------------------- //
const state = proxy({
    loading: false,
    open: false,
    shake: false
});
// -- Controller ---------------------------------------- //
export const ModalController = {
    state,
    subscribe(callback) {
        return sub(state, () => callback(state));
    },
    subscribeKey(key, callback) {
        return subKey(state, key, callback);
    },
    async open(options) {
        await ApiController.prefetch();
        const caipAddress = ChainController.state.activeCaipAddress;
        const noAdapters = ChainController.state.noAdapters;
        if (options?.view) {
            RouterController.reset(options.view);
        }
        else if (caipAddress) {
            RouterController.reset('Account');
        }
        else if (noAdapters && !CoreHelperUtil.isMobile()) {
            RouterController.reset('ConnectingWalletConnectBasic');
        }
        else {
            RouterController.reset('Connect');
        }
        state.open = true;
        PublicStateController.set({ open: true });
        EventsController.sendEvent({
            type: 'track',
            event: 'MODAL_OPEN',
            properties: { connected: Boolean(caipAddress) }
        });
    },
    close() {
        const isEmbeddedEnabled = OptionsController.state.enableEmbedded;
        const connected = Boolean(ChainController.state.activeCaipAddress);
        state.open = false;
        if (isEmbeddedEnabled) {
            if (connected) {
                RouterController.replace('Account');
            }
            else {
                RouterController.push('Connect');
            }
        }
        else {
            PublicStateController.set({ open: false });
        }
        EventsController.sendEvent({
            type: 'track',
            event: 'MODAL_CLOSE',
            properties: { connected }
        });
        ConnectorController.clearNamespaceFilter();
    },
    setLoading(loading) {
        state.loading = loading;
        PublicStateController.set({ loading });
    },
    shake() {
        if (state.shake) {
            return;
        }
        state.shake = true;
        setTimeout(() => {
            state.shake = false;
        }, 500);
    }
};
//# sourceMappingURL=ModalController.js.map